import React, { useEffect, useState } from 'react'
import './divider.css'
import { types } from '../types.js'

export function Divider({ page, component }) {
  const COLORS = {
    BRAND_BLUE: 'Brand blue',
    DARK_BLUE: 'Dark blue',
    LIGHT_GRAY: 'Light gray',
  }

  const BAR_COLORS = {
    'Brand blue': 'u-bgColorBrandExtraLight',
    'Dark blue': 'u-bgColorBrandDarker',
    'Light gray': 'custom-divider',
  }

  const [parameter, setParameter] = useState({
    color: COLORS.BRAND_BLUE,
  })

  useEffect(() => {
    const _parameters = component?.getParameters()

    setParameter({
      color: _parameters.color || COLORS.BRAND_BLUE,
    })
  }, [page, component])

  return (
    <div
      className={`${
        parameter.color === COLORS.LIGHT_GRAY ? 'u-sizeConstrained' : ''
      }`}
    >
      <div className={`Divider ${BAR_COLORS[parameter.color]}`} />
    </div>
  )
}

Divider.propTypes = {
  ...types,
}
